import { PropsOf } from 'types';
import connect from './connect';
import VideoExportNotification from './VideoExportNotification';

export default connect(VideoExportNotification);
export type VideoExportNotificationProps = PropsOf<ReturnType<typeof connect>>;
